import React from 'react';
import styled, { css } from 'styled-components';

import { useCardContext } from './card-context';

type CardSponsoredTagProps = {
  /** Override bottom margin (px). Defaults to 6. */
  marginBottom?: number;
  /** Optional desktop override for margin-bottom (≥740px). When set, enables responsive margin. */
  desktopMarginBottom?: number;
};

/** Renders the "Sponsored" label when the product is ad-sponsored. */
export function CardSponsoredTag({
  marginBottom = 6,
  desktopMarginBottom,
}: CardSponsoredTagProps = {}): JSX.Element | null {
  const { isSponsored, hideSponsoredTag } = useCardContext();

  if (!isSponsored || hideSponsoredTag) {
    return null;
  }

  return (
    <Sponsored $marginBottom={marginBottom} $desktopMarginBottom={desktopMarginBottom}>
      Sponsored
    </Sponsored>
  );
}

const Sponsored = styled.div<{ $marginBottom: number; $desktopMarginBottom?: number }>`
  color: #828a8f;
  font-size: 10px;
  font-weight: 400;
  line-height: 1;
  margin-bottom: ${({ $marginBottom }) => $marginBottom}px;

  ${({ $desktopMarginBottom }) =>
    $desktopMarginBottom != null &&
    css`
      @media screen and (min-width: 740px) {
        margin-bottom: ${$desktopMarginBottom}px;
      }
    `}
`;
